export default __webpack_public_path__ + "static/media/pattern-checked.c9b4a445.png";